module.exports = __webpack_public_path__ + "media/toolkits/HVAC-mobile-dataViz-cf22de11.png";